import { createFileRoute } from '@tanstack/react-router';
import { SeoLayout } from '@/components/astro/new-design-25/SEO/seo-layout';
import { seo } from '@/seo/seo';

const heroTitle = 'Text to Speech Tool';
const heroDescription =
  'Advanced text to speech tool with natural AI voices. Convert any text into high-quality audio with customizable speed, pitch, and voice options.';

const featureTitle = heroTitle;
const featureSubtitle = 'Professional text to speech';
const featureDescription = heroDescription;
const featureBadge = 'Advanced Features';
const featureVariant = 'default';
const featureCtaText = 'Try TTS Tool';

const featureFeatures = [
  {
    title: 'Customizable Voice Settings',
    description:
      'Adjust speed, pitch, and volume to create the perfect listening experience for your needs.',
  },
  {
    title: '24-Hour Read-Along Links',
    description:
      'Open generated audio in a temporary reader with synced text, a playbar, speed controls, and sharing.',
  },
  {
    title: 'Batch Processing',
    description:
      'Convert multiple texts or documents simultaneously to save time and increase productivity.',
  },
];

export const Route = createFileRoute('/_marketing/_seo/text-to-speech-tool')({
  head: () => ({
    meta: [
      ...seo({
        title:
          'Text to Speech Tool - Advanced TTS with Natural Voices | Listening',
        description:
          'Professional text to speech tool with customizable AI voices. Convert text to audio with adjustable speed, synced text, and a 24-hour read-along link.',
      }),
    ],
  }),
  component: () => (
    <SeoLayout
      featureBadge={featureBadge}
      featureCtaText={featureCtaText}
      featureDescription={featureDescription}
      featureFeatures={featureFeatures}
      featureSubtitle={featureSubtitle}
      featureTitle={featureTitle}
      featureVariant={featureVariant}
      pageDescription={heroDescription}
      pageTitle={heroTitle}
    />
  ),
});
